import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";



export default function ClubPolicy({ clubId }) {
  const [content, setContent] = useState("");
 
  const [created, setCreated] = useState("");
  const [updated, setUpdated] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const { user } = useAuthContext();

  const fetchPolicy = async () => {

    try {

      
      const res = await axios.get(
        `${ApiConnectionString}/api/clubPolicy/${clubId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      console.log(res.data)

      if (res.status === 200) {
        setContent(res.data.policyContent || "");
        setCreated(res.data.policyCreated || null);
        setUpdated(res.data.policyUpdated || null);
      }
    } catch (err) {
      setMessage("Failed to load policy.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPolicy();
  }, [clubId, user.token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const newPolicy = {
        policyContent: content,
        clubId,
      };
      await axios.post(`${ApiConnectionString}/api/ClubPolicy`, newPolicy, {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      setMessage("Policy saved successfully.");
      setEditMode(false);
    } catch (err) {
      setMessage("Failed to save policy.");
    } finally {
      fetchPolicy();
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="container py-5">
      <div className="card shadow rounded-4 p-4">
        <h2 className="mb-4 fw-bold text-dark">
          {created ? "Club Policy" : "Create Club Policy"}
        </h2>

        {!editMode ? (
          <>
            <div className="mb-3">
              {content ? (
                <p className="text-dark">{content}</p>
              ) : (
                <p className="text-muted fst-italic">No policy available.</p>
              )}
            </div>
            <button
              className="btn btn-outline-primary rounded-3 px-4 py-2"
              onClick={() => setEditMode(true)}
            >
              {content ? "Edit Policy" : "Create Policy"}
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <textarea
                className="form-control rounded-3 p-3"
                rows="6"
                placeholder="Write your club policy here..."
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary rounded-3 px-4 py-2 me-2"
            >
              Save Policy
            </button>
            <button
              type="button"
              className="btn btn-secondary rounded-3 px-4 py-2"
              onClick={() => setEditMode(false)}
            >
              Cancel
            </button>
          </form>
        )}

        {message && <div className="mt-3 text-muted">{message}</div>}
      </div>
    </div>
  );
}
